import { deduplicate } from './arrays';

export const expandIngredients = (rootIngredientNames, ingredientTreeNodes) => {
  const expandedIngredientNodes = ingredientTreeNodes.filter((node) =>
    rootIngredientNames.includes(node.ingredientName),
  );
  // console.log({ expandedIngredientNodes });
  let nextNodesToAdd;
  const MAX_DEPTH = 20;
  let depth = 1;
  do {
    const existingIngredientNames = expandedIngredientNodes.map(
      (node) => node.ingredientName,
    );
    nextNodesToAdd = ingredientTreeNodes.filter(
      (node) =>
        !existingIngredientNames.includes(node.ingredientName) &&
        existingIngredientNames.includes(node.parentIngredientName),
    );
    // console.log({ nextNodesToAdd });
    expandedIngredientNodes.push(...nextNodesToAdd);
    depth += 1;
  } while (nextNodesToAdd.length > 0 && depth < MAX_DEPTH);
  return expandedIngredientNodes;
};

export const allIngredientNames = (ingredientTreeNodes) =>
  deduplicate(ingredientTreeNodes.map((node) => node.ingredientName));

export const preparationString = (ingredient) => {
  const prepTokens = (ingredient.tokens || []).filter(
    (token) => token.label === 'PREP',
  );
  const stringPieces = prepTokens.map((token) =>
    ingredient.tokFullText.substring(token.fromChar, token.toChar),
  );
  return stringPieces.join(' ');
};

export const ingredientWithTokensRemoved = (ingredient, tokenTypeToRemove) => {
  let numCharsRemoved = 0;
  let newTokFullText = ingredient.tokFullText;
  // eslint-disable-next-line no-restricted-syntax
  for (const token of ingredient.tokens) {
    if (token.label === tokenTypeToRemove) {
      newTokFullText =
        newTokFullText.substring(0, token.fromChar - numCharsRemoved) +
        newTokFullText.substring(token.toChar - numCharsRemoved);
      numCharsRemoved += token.toChar - token.fromChar;
    }
  }
  return {
    ...ingredient,
    tokFullText: newTokFullText,
    tokens: ingredient.tokens.filter(
      (token) => token.label !== tokenTypeToRemove,
    ),
  };
};

export const ingredientWithTokenAdded = (
  ingredient,
  tokenType,
  tokenString,
) => {
  const separatorString = tokenType === 'PREP' ? ', ' : ' ';
  const newToken = {
    label: tokenType,
    fromChar: ingredient.tokFullText.length + separatorString.length,
    toChar:
      ingredient.tokFullText.length +
      separatorString.length +
      tokenString.length,
  };
  return {
    ...ingredient,
    tokFullText: `${ingredient.tokFullText}${separatorString}${tokenString}`,
    tokens: [...(ingredient.tokens || []), newToken],
  };
};

export const rewritePreparation = (ingredient, newPreparation) =>
  ingredientWithTokenAdded(
    ingredientWithTokensRemoved(ingredient, 'PREP'),
    'PREP',
    newPreparation,
  );

export const arraySectionFullTextIsHeading = (fullText) => {
  return fullText && fullText.slice(0, 1) === '(' && fullText.slice(-1) === ')';
};
